module.exports = __webpack_public_path__ + "img/livesupport_liveflamingo.9beeecfe.svg";